import React from 'react';
import styled from 'styled-components';
import {
  //  Level,
  Label,
  Tab,
} from 'rbx';
// import { useStoreState } from 'easy-peasy';
// import swal from 'sweetalert';
import { toast } from 'react-toastify';

import {
  Input,
  TextArea,
  // Radio,
  // CheckBox,
  ReactDateTimePicker,
  MobileInput,
  Select,
  TagInputs,
  InputErrorMessage,
  Tabs,
} from '../../../components/elements';
import Footer2 from './Footer2';
import BookingSlotsList from './BookingSlotsList';

const Container = styled.div`
  &&& {
    z-index: 2000;
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 80vh;
      padding: 0rem 1rem;
    }
    .modal-card {
      max-height: calc(100vh - 140px);
      position: absolute;
      width: 80vw;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1.5rem 1rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: flex-end;
      border: 0px;
      padding: 1rem;
      background: white;
    }
    a {
      font-size: 1rem;
    }
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 480px 480px;
  gap: 10px;
  padding: 10px;
`;

const GridItem = styled.div`
  padding: 5px 20px;
  text-align: left;
`;

// const ActionButtonsContainer = styled.div`
//   position: relative;
//   left: 40px;
//   width: 700px;
//   display: flex;
//   flex-direction: row;
//   padding: 0 0 30px 0;
// `;

// const Gap = styled.div`
//   margin: 0 1rem;
// `;

const parseData = parseValue => {
  const final = [];
  parseValue.forEach(item => {
    final.push({ value: item, label: item });
  });
  return final;
};

const parseInput = parseValue => {
  const final = [];
  (parseValue ?? []).forEach(item => {
    final.push(item.value);
  });
  return final;
};

const getTabs = bookingFee => {
  if (bookingFee) {
    return [
      {
        key: 'Booking',
        name: 'Booking',
        index: 0,
      },
    ];
  }

  return [
    {
      key: 'Booking',
      name: 'Booking',
      index: 0,
    },
  ];
};

const FormModal = ({ ...props }) => {
  const {
    values,
    tableBookingDataProps,
    isSubmitting,
    // handleSubmit,
    history,
    setFieldValue,
    errors,
    touched,
    // updateTableBooking,
    updateTableBookingError,
    tableSettingProps,
    isAdd,
    isActive,
    onClose,
    onSubmit,
  } = props;

  const [activeTab, setActiveTab] = React.useState(0);

  // const { userId: adminUserId } = useStoreState(state => state.auth);

  const {
    placeId,
    // tableBookingId
  } = props;

  const tempDate2 = new Date(values.booking_date);

  // const minDate = React.useRef(values.booking_date);

  // const onChangeBookingStatus = async bookingStatus =>
  //   updateTableBooking({
  //     user_id: adminUserId,
  //     table_booking_id: tableBookingDataProps.table_booking_id,
  //     booking_status: bookingStatus,
  //   });

  // const onChangeGuestStatus = async guestStatus =>
  //   updateTableBooking({
  //     user_id: adminUserId,
  //     table_booking_id: tableBookingDataProps.table_booking_id,
  //     guest_status: guestStatus,
  //   });

  const tableDetailsOptions = (tableSettingProps?.table_details ?? []).map(
    ele => ({
      label: `${ele.table_name} ${ele.table_number} - ${ele.table_capacity}`,
      value: ele.table_number,
    }),
  );

  const tagOptions = Array.from(
    new Set([...values.tags, ...(tableSettingProps?.tag ?? [])]),
  ).map(ele => ({
    label: ele,
    value: ele,
  }));

  React.useEffect(() => {
    if (updateTableBookingError) {
      toast.error(updateTableBookingError);
    }
  }, [updateTableBookingError]);

  // if (updatingTableBooking){
  //   return <updatingTableBooking />
  // }

  const collectBookingFee = !!tableBookingDataProps?.billing?.booking_total;

  const tabs = getTabs(collectBookingFee);

  return (
    <Container className={`modal ${isActive && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Modify Booking</p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={onClose}
          />
        </header>

        <section className="modal-card-body">
          <Tabs className="tabs is-medium">
            {tabs.map(tab => (
              <Tab
                active={activeTab === tab.index}
                key={tab.key}
                onClick={() => setActiveTab(tab.index)}
              >
                {tab.name}
              </Tab>
            ))}
          </Tabs>
          {activeTab === 0 && (
            <>
              <GridContainer>
                <GridItem>
                  <div className="is-flex">
                    <div style={{ padding: '5px 10px' }}>
                      <Label>Booking Date</Label>
                    </div>
                    <ReactDateTimePicker
                      value={new Date(values.booking_date)}
                      onChange={value => {
                        setFieldValue('booking_date', value);
                      }}
                      minDate={new Date()}
                    />
                  </div>
                </GridItem>
                <GridItem>
                  <div className="is-flex">
                    <div style={{ padding: '5px 10px' }}>
                      <Label>Booking Status</Label>
                    </div>
                    <div
                      style={{
                        width: '150px',
                        position: 'relative',
                        bottom: '4px',
                      }}
                    >
                      <Select
                        options={[]}
                        value={[
                          {
                            label: values.booking_status,
                            value: values.booking_status,
                          },
                        ]}
                        disableToastMessage
                        disabled
                      />
                    </div>
                  </div>
                </GridItem>
                <GridItem />
              </GridContainer>
              {/* {!isAdd && (
                <ActionButtonsContainer>
                  {values.paymentCaptured && collectBookingFee && (
                    <>
                      <button
                        className="button is-grey is-outlined"
                        onClick={() => {
                          if (values.booking_status === 'RECEIVED') {
                            swal({
                              text: 'Please confirm the table booking',
                            });
                          } else {
                            swal({
                              text:
                                'Would you like to refund this table booking?',
                              buttons: ['Cancel', 'OK'],
                            }).then(res => {
                              if (res) {
                                history.push(
                                  `/refund-booking/${placeId}/${tableBookingId}`,
                                );
                              }
                            });
                          }
                        }}
                      >
                        Refund Booking
                      </button>
                      <Gap />
                    </>
                  )}
                  <button
                    className="button is-grey is-outlined"
                    disabled={values.booking_status === 'CANCELLED'}
                    onClick={() => {
                      swal({
                        text: 'Would you like to cancel this table booking?',
                        buttons: ['Cancel', 'OK'],
                      }).then(res => {
                        if (res) {
                          history.push(
                            `/cancel-booking/${placeId}/${tableBookingId}`,
                          );
                        }
                      });
                    }}
                  >
                    Cancel Booking
                  </button>
                  <Gap />
                  <button
                    className="button is-warning is-outlined"
                    disabled={values.booking_status === 'WAITLISTED'}
                    onClick={() => {
                      if (values.booking_status === 'WAITLISTED') {
                        // pass
                      } else {
                        swal({
                          text:
                            'Would you like to waitlist this table booking?',
                          buttons: ['Cancel', 'OK'],
                        }).then(res => {
                          if (res) {
                            onChangeBookingStatus('WAITLISTED');
                            console.log('Waitlisting...');
                          }
                        });
                      }
                    }}
                  >
                    Waitlist Booking
                  </button>
                  <Gap />
                  {values.booking_status === 'CONFIRMED' && (
                    <>
                      <button
                        onClick={() => {
                          if (values.booking_status === 'CONFIRMED') {
                            // pass
                          } else {
                            swal({
                              text:
                                'Would you like to confirm this table booking?',
                              buttons: ['Cancel', 'OK'],
                            }).then(res => {
                              if (res) {
                                onChangeBookingStatus('CONFIRMED');
                                console.log('confirming...');
                              }
                            });
                          }
                        }}
                        className="button is-outlined is-primary"
                      >
                        Resend Confirmation
                      </button>
                      <Gap />
                    </>
                  )}
                  {values.booking_status !== 'CONFIRMED' && (
                    <>
                      <button
                        className="button is-primary is-outlined"
                        disabled={values.booking_status === 'CONFIRMED'}
                        onClick={() => {
                          if (values.booking_status === 'CONFIRMED') {
                            // pass
                          } else {
                            swal({
                              text:
                                'Would you like to confirm this table booking?',
                              buttons: ['Cancel', 'OK'],
                            }).then(res => {
                              if (res) {
                                onChangeBookingStatus('CONFIRMED');
                                console.log('confirming...');
                              }
                            });
                          }
                        }}
                      >
                        Confirm Booking
                      </button>
                      <Gap />
                    </>
                  )}
                </ActionButtonsContainer>
              )}
              <div className="is-flex" style={{ padding: '10px' }}>
                <div style={{ padding: '0 20px' }}>
                  <div
                    style={{
                      padding: '10px',
                      position: 'relative',
                      top: '-8px',
                    }}
                  >
                    <Label>Guest Status</Label>
                  </div>
                </div>
                <div style={{ padding: '0 25px' }}>
                  <div className="is-flex">
                    <Level.Item>
                      <div style={{ padding: '0 20px', fontWeight: '800' }}>
                        <Radio
                          stopClickFn
                          label="UPCOMING"
                          value={values.guest_status === 'UPCOMING'}
                          onChange={() => {
                            if (isAdd) {
                              setFieldValue('guest_status', 'UPCOMING');
                            } else {
                              swal({
                                text:
                                  'Would you like to UPCOMING this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  onChangeGuestStatus('UPCOMING');
                                  console.log('UPCOMING...');
                                }
                              });
                            }
                          }}
                        />
                      </div>
                    </Level.Item>
                    &nbsp;
                    <Level.Item>
                      <div style={{ padding: '0 20px', fontWeight: '800' }}>
                        <Radio
                          stopClickFn
                          label="CHECKED IN"
                          value={values.guest_status === 'CHECKEDIN'}
                          onChange={() => {
                            if (isAdd) {
                              swal({
                                text:
                                  'Would you like to CHECKED IN this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  setFieldValue('guest_status', 'CHECKEDIN');
                                }
                              });
                            } else {
                              swal({
                                text:
                                  'Would you like to CHECKED IN this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  onChangeGuestStatus('CHECKEDIN');

                                  console.log('CHECKEDIN...');
                                }
                              });
                            }
                          }}
                        />
                      </div>
                    </Level.Item>
                    &nbsp;
                    <Level.Item>
                      <div style={{ padding: '0 20px', fontWeight: '800' }}>
                        <Radio
                          stopClickFn
                          label="SEATED"
                          value={values.guest_status === 'SEATED'}
                          onChange={() => {
                            if (isAdd) {
                              swal({
                                text:
                                  'Would you like to SEATED this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  setFieldValue('guest_status', 'SEATED');
                                }
                              });
                            } else {
                              swal({
                                text:
                                  'Would you like to SEATED this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  onChangeGuestStatus('SEATED');
                                  console.log('SEATED...');
                                }
                              });
                            }
                          }}
                        />
                      </div>
                    </Level.Item>
                    &nbsp;
                    <Level.Item>
                      <div style={{ padding: '0 20px', fontWeight: '800' }}>
                        <Radio
                          stopClickFn
                          label="NO SHOW"
                          value={values.guest_status === 'NO SHOW'}
                          onChange={() => {
                            if (isAdd) {
                              swal({
                                text:
                                  'Would you like to NO SHOW this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  setFieldValue('guest_status', 'NO SHOW');
                                }
                              });
                            } else {
                              swal({
                                text:
                                  'Would you like to NO SHOW this table booking?',
                                buttons: ['Cancel', 'OK'],
                              }).then(res => {
                                if (res) {
                                  onChangeGuestStatus('NO SHOW');
                                  console.log('NOSHOW...');
                                }
                              });
                            }
                          }}
                        />
                      </div>
                    </Level.Item>
                    &nbsp;
                  </div>
                </div>
              </div> */}
              <div className="is-flex" style={{ padding: '10px' }}>
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-3px',
                      }}
                    >
                      Number of Guests{' '}
                      <span className="has-text-danger">*</span>
                    </Label>
                    <Input
                      value={values.guest_count}
                      onChange={e =>
                        setFieldValue('guest_count', e.target.value)
                      }
                      disableToastMessage
                      required
                      errors={errors.guest_count}
                      touched={touched.guest_count}
                    />
                  </div>
                </div>
                <div style={{ padding: '20px', width: '60%' }}>
                  <div
                    className="is-flex"
                    style={{
                      padding: '10px',
                      position: 'relative',
                      top: '-32px',
                    }}
                  >
                    <div style={{ width: '400px' }}>
                      <Select
                        label="Table Number"
                        options={tableDetailsOptions}
                        value={(() =>
                          tableDetailsOptions.find(
                            tdo => tdo.value === values.table_number,
                          ))()}
                        onChange={value =>
                          setFieldValue('table_number', value.value)
                        }
                        disableToastMessage
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ position: 'relative', top: '-2rem' }}>
                <div className="is-flex">
                  <div style={{ padding: '0 40px' }}>
                    <Label>
                      Booking Time <span className="has-text-danger">*</span>
                    </Label>
                    <InputErrorMessage
                      errors={errors.booking_time}
                      touched={touched.booking_time}
                      disableToastMessage
                    />
                  </div>
                  <div>
                    <Label>{values.booking_time}</Label>
                  </div>
                </div>
                <BookingSlotsList
                  isAdd={isAdd}
                  placeId={placeId}
                  setFieldValue={setFieldValue}
                  serviceTypeSettingId={
                    props?.tableSettingProps?.service_type_setting_id
                  }
                  booking_time={values.booking_time}
                  date={tempDate2}
                />
              </div>
              <div
                className="is-flex"
                style={{ padding: '0 10px', marginTop: '-12px' }}
              >
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-4px',
                      }}
                    >
                      Guest First Name{' '}
                      <span className="has-text-danger">*</span>
                    </Label>
                    <Input
                      value={values.first_name}
                      onChange={e =>
                        setFieldValue('first_name', e.target.value)
                      }
                      disableToastMessage
                      errors={errors.first_name}
                      touched={touched.first_name}
                      required
                    />
                  </div>
                </div>
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-4px',
                      }}
                    >
                      Guest Last Name <span className="has-text-danger">*</span>
                    </Label>
                    <Input
                      value={values.last_name}
                      onChange={e => setFieldValue('last_name', e.target.value)}
                      disableToastMessage
                      errors={errors.last_name}
                      touched={touched.last_name}
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                className="is-flex"
                style={{ padding: '10px', marginTop: '-12px' }}
              >
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-4px',
                      }}
                    >
                      Email <span className="has-text-danger">*</span>
                    </Label>
                    <Input
                      value={values.contact_email}
                      onChange={e =>
                        setFieldValue('contact_email', e.target.value)
                      }
                      disableToastMessage
                      errors={errors.contact_email}
                      touched={touched.contact_email}
                      required
                    />
                  </div>
                </div>
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-4px',
                      }}
                    >
                      Phone <span className="has-text-danger">*</span>
                    </Label>
                    <MobileInput
                      name="contact_phone"
                      // label="Primary Contact Phone"
                      value={values.contact_phone}
                      errors={errors.contact_phone}
                      touched={touched.contact_phone}
                      // onChange={value => setFieldValue('primaryMobile', value)}
                      required
                      onChange={e => setFieldValue('contact_phone', e)}
                      disableToastMessage
                    />
                  </div>
                </div>
                <div style={{ padding: '20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        top: '-4px',
                      }}
                    >
                      Source
                    </Label>
                    <Input value={values.platform} disabled />
                  </div>
                </div>
              </div>
              <div style={{ padding: '0 40px' }}>
                <Label>Guest Requests</Label>
                <TextArea
                  value={values.guest_notes}
                  onChange={e => setFieldValue('guest_notes', e.target.value)}
                  name="Guest Requests"
                  errors={errors.guest_notes}
                  touched={touched.guest_notes}
                  optionalText="(Max 144 Characters)"
                />
                {values.guest_notes && (
                  <div style={{ textAlign: 'right' }}>
                    {values.guest_notes.length > 144 ||
                    values.guest_notes.length < 1
                      ? ''
                      : `Characters left ${144 - values.guest_notes.length}`}
                  </div>
                )}

                <br />

                <Label>Restaurant Notes</Label>
                <TextArea
                  value={values.restaurant_notes}
                  onChange={e =>
                    setFieldValue('restaurant_notes', e.target.value)
                  }
                  name="Restaurant Requests"
                  errors={errors.restaurant_notes}
                  touched={touched.restaurant_notes}
                  optionalText="(Max 144 Characters)"
                />
                {values.restaurant_notes && (
                  <div style={{ textAlign: 'right' }}>
                    {values.restaurant_notes.length > 144 ||
                    values.restaurant_notes.length < 1
                      ? ''
                      : `Characters left ${144 -
                          values.restaurant_notes.length}`}
                  </div>
                )}
              </div>
              <br />
              {/* <div className="is-flex" style={{ padding: '0 10px' }}>
                <div style={{ padding: '20px 20px 0 20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        bottom: '11px',
                      }}
                    >
                      Email Notification
                    </Label>
                    <CheckBox
                      value={values.emailNotif}
                      onChange={e => {
                        setFieldValue('emailNotif', e);
                      }}
                    />
                  </div>
                </div>
                <div style={{ padding: '20px 20px 0 20px' }}>
                  <div className="is-flex">
                    <Label
                      style={{
                        padding: '10px',
                        position: 'relative',
                        bottom: '11px',
                      }}
                    >
                      SMS Notification
                    </Label>
                    <CheckBox
                      value={values.smsNotif}
                      onChange={e => {
                        setFieldValue('smsNotif', e);
                      }}
                    />
                  </div>
                </div>
              </div>
              <br /> */}
              <div className="is-flex" style={{ padding: '0 10px' }}>
                <div
                  style={{
                    padding: '0 20px',
                    marginBottom: '60px',
                    marginLeft: '10px',
                  }}
                >
                  <div style={{ width: '500px' }}>
                    <TagInputs
                      label="Tags / Occasion"
                      value={parseData(values.tags)}
                      suggestions={tagOptions}
                      onChange={value => {
                        setFieldValue('tags', parseInput(value));
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          <Footer2
            isAdd={isAdd}
            isSubmitting={isSubmitting}
            handleSubmit={onSubmit}
            history={history}
            onClose={onClose}
          />
        </section>
      </div>
    </Container>
  );
};

export default FormModal;
